/**
 * @module app.track.mobiledrawing
 */
import appBase from '../index.js';
import {MAIN_MENU_EVENT_NAME, TRACK_EVENT_NAME} from "../constants";

class Controller {

  /**
   * @param {angular.Scope} $scope Angular scope.
   * @param {ui.router.$stateParams} $stateParams
   * @param {app.CacheBustService} appCacheBustService
   * @param {angularGettext.Catalog} gettextCatalog
   * @ngInject
   */
  constructor($scope, $stateParams, appCacheBustService, gettextCatalog) {

    /**
     * @private
     */
    this.scope_ = $scope;

    /**
     * @private
     */
    this.stateParams_ = $stateParams;

    /**
     * @type {angularGettext.Catalog}
     */
    this.gettextCatalog = gettextCatalog;

    /**
     * @export
     * @type {boolean}
     */
    this.visible = false;

    /**
     * @export
     * @type {boolean}
     */
    this.create;

    /**
     * @export
     */
    this.iconCancel = appCacheBustService.addSuffix('img/track/cancel.png');

    /**
     * @export
     */
    this.iconDeleteLastPoint = appCacheBustService.addSuffix('img/track/delete-last-point.png');

    this.scope_.$on(MAIN_MENU_EVENT_NAME.COLLAPSE, () => {
      this.visible = true;
    });

    this.scope_.$on(MAIN_MENU_EVENT_NAME.EXPAND, () => {
      this.visible = false;
    });

  }

  $onInit() {
    this.create = this.stateParams_['create'];
  }

  /**
   * @export
   */
  cancel() {
    bootbox.confirm({
      buttons: {
        confirm: {
          label: this.gettextCatalog.getString('Yes')
        },
        cancel: {
          label: this.gettextCatalog.getString('No')
        }
      },
      title: this.gettextCatalog.getString('Cancel'),
      message: this.gettextCatalog.getString('Your changes have not been saved. Do you really want to cancel?'),
      callback: (result) => {
        if (result) {
          this.scope_.$root.$broadcast(TRACK_EVENT_NAME.CANCEL_DRAWING);
        }
      }
    });
  }

  /**
   * @export
   */
  deleteLastPoint() {
    this.scope_.$root.$broadcast(TRACK_EVENT_NAME.DELETE_LAST_POINT);
  }

  /**
   * @export
   */
  finishMobileDrawing() {
    this.scope_.$root.$broadcast(TRACK_EVENT_NAME.FINISH_DRAWING);
  }

}

const component = {
  controller: Controller,
  templateUrl: 'js/app/track/edit/partial-mobile-drawing.html'
};

export default appBase.component('appTrackMobileDrawing', component);
